import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { CoreData } from "../tools/core-data/core-data";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoadingTask } from "../tools/ui/loading-task";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { mapper } from "../tools/mapping/mapper";
import { SamplerAddressDTO } from "./dto/sampler-address.dto";
import { SamplerAddress } from "../model/sampler-address";

@Injectable({
    providedIn: 'root',
})
export class AddressService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/samplerAddress`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    getAdresses(samplerPuid: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${samplerPuid}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getAdresses')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: SamplerAddressDTO[]) => {
                return response.map((item: SamplerAddressDTO) => {
                    return mapper.map(item, SamplerAddressDTO, SamplerAddress);
                });
            }));
    }

}